import React, { useState, useEffect } from 'react'
/* Mattlib */
import TextFields_Outlined from './TextFields_Outlined';
import ProgressBar from './ProgressBar';
import TranslationContent_IEP from './TranslationContents/TranslationContent_IEP'
import TranslationContent_Transcript from './TranslationContents/TranslationContent_Transcript'
import TranslationContent_Letter from './TranslationContents/TranslationContent_Letter'
import TranslationContent_SchoolDocument from './TranslationContents/TranslationContent_SchoolDocument'
import TranslationContent_Evaluations from './TranslationContents/TranslationContent_Evaluations'
import TranslationContent_Other from './TranslationContents/TranslationContent_Other'
import MultipleSelect_Checkbox from './MultiSelect_Checkbox'
import MultiSelect_Checkbox_Outlined from './MultiSelect_Checkbox_Outlined'
import Dropdown_Advanced from './Dropdown_Advanced'
import TextFields_Outlined_Phone from './TextMasks/TextMask_Phone'
import TextArea_Simple from './TextArea_Simple'
import MySectionBlock from './MySectionBlock'
import ValidationModal from './ValidationModal';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

/* Button */
import Button from '@material-ui/core/Button';
/* Grid */
import { createTheme, ThemeProvider  } from "@material-ui/core";
/* Fade in */
import FadeIn from './FadeIn'
/* Date Picker 
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";*/
/* Data JSON */
import languages from '../data/languages.json'
import districts from '../data/districts.json'
import schools from '../data/schools.json'

import ColumnStatus from './ColumnStatus'

/* Bottom Nav */


/* Context */
import ContentContext from './ContentContext'
import { TranslationColumn1Context } from './TranslationContexts/TranslationColumn1Context'

/* Bootstrap */
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import 'bootstrap/dist/css/bootstrap.min.css';
import MultipleSelect from './MultiSelect_Checkbox';

/* Accordion */
import Directions_Accordion from './Directions_Accordion'
/* Date Picker */
import DatePicker_Simple from './DatePicker_Simple'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FcCalendar } from 'react-icons/fc';

// Context
import { useTranslation, useTranslationUpdate} from './TranslationContexts/TranslationDataContext'
import { ControlPointSharp } from '@material-ui/icons';

import { useDispatch, useSelector } from 'react-redux'
import {leftColFilledOutUpdated,coserUpdated,translationTypesUpdated,iep_checkedUpdated,transcript_checkedUpdated,letter_checkedUpdated,schoolDocument_checkedUpdated,evaluations_checkedUpdated,other_checkedUpdated, iepTextUpdated,transcriptTextUpdated,letterTextUpdated,schoolDocumentTextUpdated,evaluationsTextUpdated,otherTextUpdated, contactNameTextUpdated, studentDistrictDropdownUpdated, districtDropdownUpdated, schoolDropdownUpdated, languageDropdownUpdated, otherLanguageTextUpdated, contactPhoneTextUpdated, contactEmailTextUpdated, approverNameTextUpdated, approverPositionTextUpdated, approverEmailTextUpdated, districtNotesTextUpdated, dueDateTextUpdated,calendarCheckedUpdated, flyer_checkedUpdated, handbook_checkedUpdated, permissionSlip_checkedUpdated, schedules_checkedUpdated, healthForms_checkedUpdated } from '../redux/slices/translationSlice'


const TranslationContent = ({ handleContinueButton, handleProgressBarChange }) => {
  const today = new Date();
  const theme = createTheme((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }));

  const dispatch = useDispatch();
  const translationState = useSelector((state) => state.translation); // Access translation state
  const handleTranslationTypeChanges = (selectedTypes) => {
    if (!Array.isArray(selectedTypes)) {
      console.error("Expected selectedTypes to be an array");
      dispatch(translationTypesUpdated([]));
      return;
    }
    dispatch(translationTypesUpdated(selectedTypes));
  }
  const [progressBarClass, setProgressBarClass] = useState('')
  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Left Column - Use Effect
  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    //alert("RUN")
    updateLeftColumn();
  }, [translationState.translationTypes]);
  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  const updateLeftColumn = () => {
    if (!translationState.translationTypes) return;

    // IEP
    let iep = translationState.translationTypes.includes("IEP")
    dispatch(iep_checkedUpdated(iep))
    // Translation
    let transcript = translationState.translationTypes.includes("Transcript")
    dispatch(transcript_checkedUpdated(transcript))
    // Letter
    let letter = translationState.translationTypes.includes("Letter")
    dispatch(letter_checkedUpdated(letter))
    // School Document
    let schoolDocument = translationState.translationTypes.includes("School Document")
    dispatch(schoolDocument_checkedUpdated(schoolDocument))
    // Evaluations
    let evaluations = translationState.translationTypes.includes("Evaluations")
    dispatch(evaluations_checkedUpdated(evaluations))
    // Other
    let other = translationState.translationTypes.includes("Other")
    dispatch(other_checkedUpdated(other))
  }


  //const [col1RequiredFields, setCol1RequiredFields] = useState({})
  const [column1Complete, setColumn1Complete] = useState(false)
  const updateColumn1Count = (id, valueInInput) => {
    translationState[id] = valueInInput

  }
  const renderColumn1ColumnStatus = () => {
    let completed = translationState.leftColFilledOut >= 50 ? true : false
    return <ColumnStatus complete={completed} />
  }
  //////////////////////////////////////////////////////////////
  const updateNonRequireField = (id, valueInInput) =>{
    translationState[id] = valueInInput
  }
  //////////////////////////////////////////////////////////////
  // Column 2
  //////////////////////////////////////////////////////////////
  // States
  const [currentDistrict, setCurrentDistrict] = useState("")
  const [column2Complete, setColumn2Complete] = useState(false)
  const [renderOtherLang, setRenderOtherLang] = useState(false)
  const [renderCoser, setRenderCoser] = useState(false)
  const [col2RequiredFields, setCol2RequiredFields] = useState(
    {
      dueDateText: '',
      districtDropdown: '',
      schoolDropdown: '',
      languageDropdown: '',
      contactNameText: '',
      contactPhoneText: '',
      contactEmailText: '',
      approverNameText: '',
      approverPositionText: '',
      approverEmailText: ''
    }
  )

  const updateColumn2Count = (id, valueInInput) => {
    let allFilledOut = true;
    return;

    if (id == "coser"){
      //dispatch(coserUpdated(valueInInput));
    }
    else{
      translationState[id] = valueInInput;
    }
    for (var key in col2RequiredFields) {
     // console.log("key " + key + " has value " + col2RequiredFields[key]);
      if (key == id) {
        col2RequiredFields[key] = valueInInput
        // Set the POST obj
      translationState[key] = valueInInput;
      }
      if (col2RequiredFields[key] == "") {
        allFilledOut = false;
      }
      
    }
    if (id == "districtDropdown") {
      setCurrentDistrict(valueInInput)
    }
    //setColumn2Complete(allFilledOut)
    //setProgressBarDataInParent();
  }
  const checkCol2AtStart = () =>{
    //alert("checkCol2AtStart")
    col2RequiredFields["dueDateText"] = translationState.dueDateText
    col2RequiredFields["districtDropdown"] = translationState.districtDropdown
    col2RequiredFields["schoolDropdown"] = translationState.schoolDropdown
    col2RequiredFields["languageDropdown"] = translationState.languageDropdown
    col2RequiredFields["contactNameText"] = translationState.contactNameText
    col2RequiredFields["contactPhoneText"] = translationState.contactPhoneText
    col2RequiredFields["contactEmailText"] = translationState.contactEmailText
    col2RequiredFields["approverNameText"] = translationState.approverNameText
    col2RequiredFields["approverPositionText"] = translationState.approverPositionText
    col2RequiredFields["approverEmailText"] = translationState.approverEmailText
    var allFilledOut = true;
    for (var key in col2RequiredFields) {
      if (col2RequiredFields[key] == "") {
        //alert(col2RequiredFields[key] + "FAILED")
        allFilledOut = false;
      }
      
    }
    //alert("FILLED OUT: " + allFilledOut)
    setColumn2Complete(allFilledOut)
    setTimeout(function(){
      setColumn2Complete(allFilledOut)
      //alert("FILLED OUT 2: " + allFilledOut)
    },500)
  }
  const renderColumn2ColumnStatus = () => {
    let completed = translationState.rightColFilledOut >= 50 ? true : false
    return <ColumnStatus complete={completed} />
  }
  //////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////

  const handleThisContinueButton = function (newState) {
    handleContinueButton(newState)
  }

  //const progressBarData = { bgcolor: "#00695c", completed: 0 }
  //const [progressBarPercent, setProgressBarPercent] = useState(0)

  const setProgressBarDataInParentOLD = () => {
    let temp = 0;
    //alert("COMPLETE: " + column1Complete)
    // Col 1 - this is dynamic so use this field instead
    if (column1Complete) temp += 50;
    // Col 2
    if (col2RequiredFields.dueDateText != "" || translationState.dueDateText != "") temp += 5;
    if (col2RequiredFields.districtDropdown != "" || translationState.districtDropdown != "") temp += 5;
    if (col2RequiredFields.schoolDropdown != "" || translationState.schoolDropdown != "") temp += 5;
    if (col2RequiredFields.languageDropdown != "" || translationState.languageDropdown != "") temp += 5;
    if (col2RequiredFields.contactNameText != "" || translationState.contactNameText != "") temp += 5;
    if (col2RequiredFields.contactPhoneText != "" || translationState.contactPhoneText != "") temp += 5;
    if (col2RequiredFields.contactEmailText != "" || translationState.contactEmailText != "") temp += 5;
    if (col2RequiredFields.approverNameText != "" || translationState.approverNameText != "") temp += 5;
    if (col2RequiredFields.approverPositionText != "" || translationState.approverPositionText != "") temp += 5;
    if (col2RequiredFields.approverEmailText != "" || translationState.approverEmailText != "") temp += 4;
    if (translationState.districtDropdown && (!translationState.districtDropdown.includes("Nassau BOCES") || (translationState.districtDropdown.includes("Nassau BOCES") && translationState.coser != ""))) temp += 1;
    handleProgressBarChange(parseInt(temp))
  }
  const setProgressBarDataInParent = () => {
    let temp = 0;
    //alert("COMPLETE: " + column1Complete)
    // Col 1 - this is dynamic so use this field instead
    if (column1Complete) temp += 50;
    // Col 2
    if (col2RequiredFields.dueDateText != "" || translationState.dueDateText != "") temp += 5;
    if (col2RequiredFields.districtDropdown != "" || translationState.districtDropdown != "") temp += 5;
    if (col2RequiredFields.schoolDropdown != "" || translationState.schoolDropdown != "") temp += 5;
    if (col2RequiredFields.languageDropdown != "" || translationState.languageDropdown != "") temp += 5;
    if (col2RequiredFields.contactNameText != "" || translationState.contactNameText != "") temp += 5;
    if (col2RequiredFields.contactPhoneText != "" || translationState.contactPhoneText != "") temp += 5;
    if (col2RequiredFields.contactEmailText != "" || translationState.contactEmailText != "") temp += 5;
    if (col2RequiredFields.approverNameText != "" || translationState.approverNameText != "") temp += 5;
    if (col2RequiredFields.approverPositionText != "" || translationState.approverPositionText != "") temp += 5;
    if (col2RequiredFields.approverEmailText != "" || translationState.approverEmailText != "") temp += 4;
    if (translationState.districtDropdown && (!translationState.districtDropdown.includes("Nassau BOCES") || (translationState.districtDropdown.includes("Nassau BOCES") && translationState.coser != ""))) temp += 1;
    //handleProgressBarChange(parseInt(temp))
    handleProgressBarChange(100)
  }


  useEffect(() => { 
    const timer = setTimeout(() => {
      //setRenderOnceMaster();
      //console.log(column1Complete, column2Complete);
    }, 500);
    return () => clearTimeout(timer);
  }, [translationState.translationTypes]);

  useEffect(() => {
    return;
    const timer = setTimeout(() => {
      setProgressBarDataInParent();
      //console.log(column1Complete, column2Complete);
    }, 100);
    return () => clearTimeout(timer);
  }, [column1Complete, column2Complete]);
  /*
  useEffect(() => {
    const timer = setTimeout(() => {
      setProgressBarDataInParent();
      //console.log(column1Complete, column2Complete);
    }, 100);
    return () => clearTimeout(timer);
  }, [column1Complete, column2Complete]);*/
  
  //////////////////////////////////////////////////////////////
  //  Due Date
  //////////////////////////////////////////////////////////////
  const [startDueDate, setStartDueDate] = useState(translationState.dueDateText)
  //////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////
  // Validations
  //////////////////////////////////////////////////////////////approver email
  const [validate_contactPhone, setValidation_contactPhone] = useState('')
  const [validate_contactEmail, setValidation_contactEmail] = useState('')
  const [validate_approverEmail, setValidation_approverEmail] = useState('')
  const [validate_coser, setValidation_coser] = useState('')

  // Validation Modal State
  const [validationModalOpen, setValidationModalOpen] = useState(false);
  const [validationModalMissingFields, setValidationModalMissingFields] = useState([]);
  const [validationModalErrors, setValidationModalErrors] = useState([]);

  // Solution 1: Detect autofill and sync values to state
  useEffect(() => {
    const detectAndSyncAutofill = () => {
      const inputs = document.querySelectorAll('input, textarea, select');
      let autofillDetected = false;

      inputs.forEach((input) => {
        // Skip MUI internal elements
        if (!input.id || input.id.startsWith('mui-') || input.id.startsWith('react-select-')) {
          return;
        }

        if (input.value && input.id) {
          const stateValue = translationState[input.id];

          if (!stateValue || stateValue !== input.value) {
            autofillDetected = true;
            console.log(`Autofill detected for field: ${input.id}`);
            mapToRedux(input.id, input.value);
            updateColumn2Count(input.id, input.value);
          }
        }
      });

      if (autofillDetected) {
        console.log('Autofill detected on Translation page, revalidating form...');
        setTimeout(() => {
          updateColumn2Count();
        }, 100);
      }
    };

    const timer1 = setTimeout(detectAndSyncAutofill, 500);
    const timer2 = setTimeout(detectAndSyncAutofill, 1000);
    const timer3 = setTimeout(detectAndSyncAutofill, 2000);

    const handleInputEvent = (e) => {
      // Skip MUI internal elements
      if (!e.target.id || e.target.id.startsWith('mui-') || e.target.id.startsWith('react-select-')) {
        return;
      }

      if (e.target.id && e.target.value) {
        mapToRedux(e.target.id, e.target.value);
        updateColumn2Count(e.target.id, e.target.value);
      }
    };

    const inputs = document.querySelectorAll('input, textarea, select');
    inputs.forEach(input => {
      input.addEventListener('input', handleInputEvent);
    });

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      inputs.forEach(input => {
        input.removeEventListener('input', handleInputEvent);
      });
    };
  }, []);

  // Solution 3: Get list of missing required fields - check Redux state only
  const getMissingRequiredFields = () => {
    const missingFields = [];

    // Translation Types - must select at least one
    if (!translationState.translationTypes || translationState.translationTypes === '' ||
        (Array.isArray(translationState.translationTypes) && translationState.translationTypes.length === 0)) {
      missingFields.push('Translation Type(s) - must select at least one');
    }

    // Due Date
    if (!translationState.dueDateText || translationState.dueDateText === '') {
      missingFields.push('Due Date');
    }

    // District
    if (!translationState.districtDropdown || translationState.districtDropdown === '') {
      missingFields.push('District');
    }

    // School
    if (!translationState.schoolDropdown || translationState.schoolDropdown === '') {
      missingFields.push('School');
    }

    // Student District (conditional - required if Regional Summer School or RSIP is selected)
    if (translationState.districtDropdown && translationState.schoolDropdown &&
        (translationState.districtDropdown.includes("Regional Summer School") ||
         translationState.schoolDropdown.includes("RSIP")) &&
        (!translationState.studentDistrictDropdown || translationState.studentDistrictDropdown === '')) {
      missingFields.push('Student District');
    }

    // COSER (conditional - required if Nassau BOCES is selected)
    if (translationState.districtDropdown &&
        translationState.districtDropdown.includes("Nassau BOCES") &&
        (!translationState.coser || translationState.coser === '')) {
      missingFields.push('COSER');
    }

    // Language
    if (!translationState.languageDropdown || translationState.languageDropdown === '') {
      missingFields.push('Language');
    }

    // Other Language (conditional - required if "Other" is selected)
    if (renderOtherLang && (!translationState.otherLanguageText || translationState.otherLanguageText === '')) {
      missingFields.push('Other Language (Details)');
    }

    // Contact fields
    if (!translationState.contactNameText || translationState.contactNameText === '') {
      missingFields.push('Contact Name');
    }

    if (!translationState.contactPhoneText || translationState.contactPhoneText === '') {
      missingFields.push('Contact Phone');
    }

    if (!translationState.contactEmailText || translationState.contactEmailText === '') {
      missingFields.push('Contact Email');
    }

    // Approver fields
    if (!translationState.approverNameText || translationState.approverNameText === '') {
      missingFields.push('Approver Name');
    }

    if (!translationState.approverPositionText || translationState.approverPositionText === '') {
      missingFields.push('Approver Position');
    }

    if (!translationState.approverEmailText || translationState.approverEmailText === '') {
      missingFields.push('Approver Email');
    }

    // Translation type-specific fields (conditional based on selected types)
    if (translationState.translationTypes && Array.isArray(translationState.translationTypes)) {
      if (translationState.translationTypes.includes("IEP") &&
          (!translationState.iepText || translationState.iepText === '')) {
        missingFields.push('IEP Details');
      }

      if (translationState.translationTypes.includes("Transcript") &&
          (!translationState.transcriptText || translationState.transcriptText === '')) {
        missingFields.push('Transcript Details');
      }

      if (translationState.translationTypes.includes("Letter") &&
          (!translationState.letterText || translationState.letterText === '')) {
        missingFields.push('Letter Details');
      }

      if (translationState.translationTypes.includes("School Document") &&
          (!translationState.schoolDocumentText || translationState.schoolDocumentText === '')) {
        missingFields.push('School Document Details');
      }

      if (translationState.translationTypes.includes("Evaluations") &&
          (!translationState.evaluationsText || translationState.evaluationsText === '')) {
        missingFields.push('Evaluations Details');
      }

      if (translationState.translationTypes.includes("Other") &&
          (!translationState.otherText || translationState.otherText === '')) {
        missingFields.push('Other Translation Type Details');
      }
    }

    return missingFields;
  };

  // Solution 3: Sync DOM values before validation
  const syncDOMValuesToState = () => {
    const inputs = document.querySelectorAll('input, textarea, select');
    let syncedCount = 0;

    inputs.forEach((input) => {
      // Skip MUI internal elements
      if (!input.id || input.id.startsWith('mui-') || input.id.startsWith('react-select-')) {
        return;
      }

      if (input.id && input.value) {
        const stateValue = translationState[input.id];
        if (!stateValue || stateValue !== input.value) {
          console.log(`Syncing DOM value for: ${input.id} = ${input.value}`);
          syncedCount++;
          mapToRedux(input.id, input.value);
          updateColumn2Count(input.id, input.value);
        }
      }
    });

    console.log(`Synced ${syncedCount} fields from DOM to state`);
    return syncedCount;
  };

  function runAllValidations (){
    // Sync autofilled values before validation
    const syncedCount = syncDOMValuesToState();

    // Function to check validation and provide feedback
    const checkAndProceed = () => {
      // Update the validation state
      updateColumn2Count();

      let passed = true;
      const missingFields = getMissingRequiredFields();
      const validationErrors = [];

      // Contact Phone validation
      if (translationState.contactPhoneText && !validatePhone(translationState.contactPhoneText)) {
        setValidation_contactPhone('*Please provide a 10 digit phone')
        validationErrors.push('Contact Phone: must be a valid 10-digit phone number (no ext)');
        passed = false;
      }
      else setValidation_contactPhone('')

      // Contact Email validation
      if (translationState.contactEmailText && !validateEmail(translationState.contactEmailText)) {
        setValidation_contactEmail('*Please provide a valid email')
        validationErrors.push('Contact Email: must be a valid email address');
        passed = false;
      }
      else setValidation_contactEmail('')

      // Approver Email validation
      if (translationState.approverEmailText && !validateEmail(translationState.approverEmailText)) {
        setValidation_approverEmail('*Please provide a valid email')
        validationErrors.push('Approver Email: must be a valid email address');
        passed = false;
      }
      else setValidation_approverEmail('')

      // COSER validation
      if (translationState.districtDropdown && translationState.districtDropdown.includes("Nassau BOCES")){
        if (!validateCOSER(translationState.coser)) {
          setValidation_coser('*Please provide a valid 3 digit coser')
          validationErrors.push('COSER: Must be your 3 digit COSER');
          passed = false;
        }
        else setValidation_coser('')
      } else setValidation_coser('')

      if (passed && missingFields.length === 0){
        handleThisContinueButton("approval-translation")
      }
      else{
        // Show modal with missing fields and validation errors
        setValidationModalMissingFields(missingFields);
        setValidationModalErrors(validationErrors);
        setValidationModalOpen(true);
      }
    };

    if (syncedCount > 0) {
      console.log(`Synced ${syncedCount} autofilled fields before validation`);
      // Give a moment for state to update after sync
      setTimeout(checkAndProceed, 200);
    } else {
      // No sync needed, check immediately
      checkAndProceed();
    }
  }
  function validateEmail(email){
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  function validatePhone(phone){
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if(phone.match(phoneno)) return true;
    else return false;
  }
  function validateCOSER(coser){
    var coserno = /^\d{3}$/
    if(coser.match(coserno)) return true;
    else return false;
  }

  const resetDropdownValOnConditionalChange = (label) =>{
    translationState[label] = "";
  }

  useEffect(() => {
    checkCol2AtStart();
  },[]);

  setTimeout(function(){
    updateColumn2Count()
  },600)
  
  //////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////
  // Mapping
  const mapToRedux = (id, valueInInput) => {
    switch (id) {
      case "translationTypes":
        dispatch(translationTypesUpdated(valueInInput))
        break;
      case "iepText":
        dispatch(iepTextUpdated(valueInInput))
        break;
      case "transcriptText":
        dispatch(transcriptTextUpdated(valueInInput))
        break;
      case "letterText":
        dispatch(letterTextUpdated(valueInInput))
        break;
      case "schoolDocumentText":
        dispatch(schoolDocumentTextUpdated(valueInInput))
        break;
      case "evaluationsText":
        dispatch(evaluationsTextUpdated(valueInInput))
        break;
      case "otherText":
        dispatch(otherTextUpdated(valueInInput))
        break;
      case "coser":
        dispatch(coserUpdated(valueInInput))
        break;

      // Radio buttons
      case "Calendar":
        dispatch(calendarCheckedUpdated(true))
        break;
      case "Flyer":
        dispatch(flyer_checkedUpdated(true))
        break;
      case "Letter":
        dispatch(letter_checkedUpdated(true))
        break;
      case "Handbook":
        dispatch(handbook_checkedUpdated(true))
        break;
      case "Health Forms":
        dispatch(healthForms_checkedUpdated(true))
        break;
      case "Permission Slip":
        dispatch(permissionSlip_checkedUpdated(true))
        break;
      case "Schedules":
        dispatch(schedules_checkedUpdated(true))
        break;


      case "dueDateText":
        dispatch(dueDateTextUpdated(valueInInput.toISOString()))
        break;
      case "districtDropdown":
        dispatch(districtDropdownUpdated(valueInInput))
        break;
      case "studentDistrictDropdown":
        dispatch(studentDistrictDropdownUpdated(valueInInput))
        break;
      case "schoolDropdown":
        dispatch(schoolDropdownUpdated(valueInInput))
        break;
      case "languageDropdown":
        dispatch(languageDropdownUpdated(valueInInput))
        break;
      case "contactNameText":
        dispatch(contactNameTextUpdated(valueInInput))
        break;
      case "contactPhoneText":
        dispatch(contactPhoneTextUpdated(valueInInput))
        break;
      case "contactEmailText":
        dispatch(contactEmailTextUpdated(valueInInput))
        break;
      case "approverNameText":
        dispatch(approverNameTextUpdated(valueInInput))
        break;
      case "approverPositionText":
        dispatch(approverPositionTextUpdated(valueInInput))
        break;
      case "approverEmailText":
        dispatch(approverEmailTextUpdated(valueInInput))
        break;
      case "districtNotes":
        dispatch(districtNotesTextUpdated(valueInInput))
        break;
      case "otherLanguageText":
        dispatch(otherLanguageTextUpdated(valueInInput))
        break;
      default:
        console.log("ID not found: " + id)
    }
  }
  //////////////////////////////////////////////////////////////

  const renderTranslationTypeComponents = () => {
    if (!translationState.translationTypes || translationState.translationTypes.length == 0) {
      return <></>
    }
    {/*<div style={{ display: 'flex', paddingLeft: '' }}>*Select a Translation Type or multiple to begin.</div>*/}

    let halflings = []
      if (translationState.translationTypes.includes("IEP")) {
        halflings.push(<TranslationContent_IEP 
                        id={"iepText_parent"}
                        key={""} 
                        //onChange={(e) => dispatch(iepTextUpdated(e.target.value))}
                        valueInField={translationState.iepText} 
                        classesToAdd={"required-adjusted-left"} 
                        required={true} 
                        triggerUpdateFromParent={mapToRedux} 
                        updateProgressBar={updateColumn1Count} />
                      )
      }
      if (translationState.translationTypes.includes("Transcript")) {
        halflings.push(<Row><Col><div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '0px' }}><div style={{ width: '80%'}}><TranslationContent_Transcript key={""} valueInField={translationState.transcriptText} classesToAdd={"required-adjusted-left"} required={true} triggerUpdateFromParent={mapToRedux} updateProgressBar={updateColumn1Count} /></div></div></Col></Row>)
      }
      if (translationState.translationTypes.includes("Letter")) {
        halflings.push(<Row><Col><div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '0px' }}><div style={{ width: '80%'}}><TranslationContent_Letter key={""} valueInField={translationState.letterText} classesToAdd={"required-adjusted-left"} required={true} triggerUpdateFromParent={mapToRedux} updateProgressBar={updateColumn1Count} /></div></div></Col></Row>)
      }
      if (translationState.translationTypes.includes("School Document")) {
        halflings.push(<Row><Col><div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '0px' }}><div style={{ width: '80%'}}><TranslationContent_SchoolDocument key={""} valueInField={translationState.schoolDocumentText} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateFromParent={mapToRedux} updateProgressBar={updateColumn1Count} /></div></div></Col></Row>)
      }
      if (translationState.translationTypes.includes("Evaluations")) {
        halflings.push(<Row><Col><div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '0px' }}><div style={{ width: '80%'}}><TranslationContent_Evaluations key={""} valueInField={translationState.evaluationsText} classesToAdd={"required-adjusted-left"} required={true} triggerUpdateFromParent={mapToRedux} updateProgressBar={updateColumn1Count} /></div></div></Col></Row>)
      }
      if (translationState.translationTypes.includes("Other")) {
        halflings.push(<Row><Col><div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '0px' }}><div style={{ width: '80%'}}><TranslationContent_Other key={""} valueInField={translationState.otherText} classesToAdd={"required-adjusted-left"} required={true} triggerUpdateFromParent={mapToRedux} updateProgressBar={updateColumn1Count} /></div></div></Col></Row>)
      }
    return <>{halflings}</>
  }

  return (
    <ThemeProvider theme={theme}>
      <ValidationModal
        open={validationModalOpen}
        onClose={() => setValidationModalOpen(false)}
        missingFields={validationModalMissingFields}
        validationErrors={validationModalErrors}
      />

      <div className='progress-bar-container'>
        <ProgressBar 
          key={0} 
          bgcolor={"#00695c"}
          completed={translationState.progressBar} 
          fixedClass={progressBarClass}
          isDisabed={translationState.leftColFilledOut + translationState.rightColFilledOut < 100}
          runAllValidations={runAllValidations}
        />
        
        <MySectionBlock 
          height="5px" 
          onEnterViewport={() => {
              console.log('enter viewportttt')
              setProgressBarClass('')
          }}
          onLeaveViewport={() => {
              console.log('leave viewportttt')
              setProgressBarClass('progressBar-fixed')
          }}
        />
     </div>
     <div>{/* className={classes.root}>*/}
      <FadeIn delay={200} duration={450}>
          <Container fluid className="">
            {/* Content */}
            <Row>
              <Row>
                {/* LEFT Column */}
                {/*<Col className="col-7">*/}
                  <Box style={{width: '60%', backgroundColor: '#F8F8F8', padding: '3px', marginBottom: '10px'}}>
                      <Card variant="outlined" style={{padding: '10px',}}>
                        <CardContent>
                          {/*<Row>
                            <Col>{renderColumn2ColumnStatus()}</Col>
                          </Row>
                          <Col><h4 className="content-section-title">District Information</h4><p style={{ lineHeight: '5%' }}>&nbsp;</p></Col>*/}
                          <Row>
                            <Col>
                              <p className="assessment-section-headers">District Information</p>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px', marginBottom: '7px' }}>
                                {/* Districts/School/Language */}
                                <Dropdown_Advanced required={true} valueInField={translationState.districtDropdown} classesToAdd={"required-adjusted-lower"} options={districts} prompt='District' id="districtDropdown" label="name" triggerUpdateInParent={mapToRedux} />
                                &nbsp;&nbsp; {/*lazy*/}
                                <Dropdown_Advanced required={true} valueInField={translationState.schoolDropdown} classesToAdd={"required-adjusted-lower"} condReset={resetDropdownValOnConditionalChange}
                                  options={schools} prompt='School' id="schoolDropdown" label="name" triggerUpdateInParent={mapToRedux}
                                  isConditional={true} conditionalField={translationState.districtDropdown != "" ? translationState.districtDropdown : currentDistrict} />

                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px', marginBottom: '7px' }}>
                                {
                                    translationState.districtDropdown.includes("Regional Summer School") || 
                                    translationState.schoolDropdown.includes("RSIP")
                                    ?
                                      <Dropdown_Advanced required={true} valueInField={translationState.studentDistrictDropdown} classesToAdd={"required-adjusted-lower"} options={districts} prompt='Student District' id="studentDistrictDropdown" label="name" triggerUpdateInParent={mapToRedux} />
                                    : <></>
                                }
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px', marginBottom: '7px' }}>
                                {translationState.districtDropdown.includes("Nassau BOCES") && <TextFields_Outlined valueInField={translationState.coser} classesToAdd={"required-adjusted-lower"} required={true} validationText={validate_coser}  triggerUpdateInParent={mapToRedux} id="coser" label="COSER (ex: 602)" />}
                              </div>
                            </Col>
                          </Row>
                                {/* Contact Info */}
                                <Row>
                                  <Col>
                                    <p className="assessment-section-headers">Evaluation report(s) will be sent to</p>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                  <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px', marginBottom: '7px'  }}>
                                <TextFields_Outlined required={true} valueInField={translationState.contactNameText} classesToAdd={"required-adjusted-lower"} triggerUpdateInParent={mapToRedux} id="contactNameText" label="Contact Name" />
                                &nbsp;&nbsp; {/*lazy*/}
                                <TextFields_Outlined required={true} valueInField={translationState.contactPhoneText} classesToAdd={"required-adjusted-lower"} validationText={validate_contactPhone} noSpaces={true} triggerUpdateInParent={mapToRedux} id="contactPhoneText" label="Contact Phone" />
                                &nbsp;&nbsp; {/*lazy*/}
                                <TextFields_Outlined required={true} valueInField={translationState.contactEmailText} classesToAdd={"required-adjusted-lower"} validationText={validate_contactEmail} noSpaces={true} triggerUpdateInParent={mapToRedux} id="contactEmailText" label="Contact Email" />
                                </div>
                                </Col>
                                </Row>
                                {/* Approver Info */}
                                <Row>
                                  <Col>
                                    <p className="assessment-section-headers">The request will be approved by</p>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                  <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px', marginBottom: '7px'  }}>
                                <TextFields_Outlined valueInField={translationState.approverNameText} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="approverNameText" label="Approver Name" />
                                &nbsp;&nbsp; {/*lazy*/}
                                <TextFields_Outlined valueInField={translationState.approverPositionText} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="approverPositionText" label="Approver Position" />
                                &nbsp;&nbsp; {/*lazy*/}
                                <TextFields_Outlined valueInField={translationState.approverEmailText} classesToAdd={"required-adjusted-lower"} validationText={validate_approverEmail} noSpaces={true} required={true} triggerUpdateInParent={mapToRedux} id="approverEmailText" label="Approver Email" />
                                </div>
                                </Col>
                                </Row>

                        <Row>
                          <Col>
                            <p className="assessment-section-headers">Translation Information</p>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px', marginLeft: '7px'  }}>
                              <div style={{ width: '80%'}}>
                                <MultiSelect_Checkbox_Outlined
                                  handleTranslationTypeChanges={handleTranslationTypeChanges} 
                                  triggerUpdateInParent={mapToRedux}
                                  label="Translation Type(s)" 
                                  valueInField={Array.isArray(translationState.translationTypes) ? translationState.translationTypes : []}
                                  required={true}
                                  choices={["IEP", "Transcript", "Letter", "School Document", "Evaluations", "Other"]} 
                                  classesToAdd={"required"}
                                  id={"translationTypes"}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>


                        {/* Render the translation type components */}
                        {
                          translationState.translationTypes.includes("IEP") ?
                          <Row>
                            <Col>
                              <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginBottom: '12px', width: '80%', }}>
                                
                                  <TranslationContent_IEP 
                                    id={"iepText_parent"}
                                    key={""} 
                                    //onChange={(e) => dispatch(iepTextUpdated(e.target.value))}
                                    valueInField={translationState.iepText} 
                                    classesToAdd={"required-adjusted-left"} 
                                    required={true} 
                                    triggerUpdateFromParent={mapToRedux} 
                                    updateProgressBar={updateColumn1Count} />

                              </div>
                            </Col>
                          </Row>
                          :
                          <></>
                        }
                        {/* Render the translation type components */}
                        {
                          translationState.translationTypes.includes("Transcript") ?
                          <Row>
                            <Col>
                              <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginBottom: '12px', width: '80%', }}>
                                
                                  <TranslationContent_Transcript key={"transcript_parent"} 
                                  valueInField={translationState.transcriptText} 
                                  classesToAdd={"required-adjusted-left"} 
                                  required={true} 
                                  triggerUpdateFromParent={mapToRedux} 
                                  updateProgressBar={updateColumn1Count} />

                              </div>
                            </Col>
                          </Row>
                          :
                          <></>
                        }
                        {/* Render the translation type components */}
                        {
                          translationState.translationTypes.includes("Letter") ?
                          <Row>
                            <Col>
                              <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginBottom: '12px', width: '80%',  }}>
                                
                                  <TranslationContent_Letter 
                                  key={""} 
                                  valueInField={translationState.letterText} 
                                  classesToAdd={"required-adjusted-left"} 
                                  required={true} 
                                  triggerUpdateFromParent={mapToRedux} 
                                  updateProgressBar={updateColumn1Count} />

                              </div>
                            </Col>
                          </Row>
                          :
                          <></>
                        }
                        {/* Render the translation type components */}
                        {
                          translationState.translationTypes.includes("School Document") ?
                          <Row>
                            <Col>
                              <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginBottom: '12px', width: '80%', }}>
                                
                                  <TranslationContent_SchoolDocument 
                                  key={""} 
                                  valueInField={translationState.schoolDocumentText} 
                                  classesToAdd={"required-adjusted-lower"} 
                                  required={true} 
                                  triggerUpdateFromParent={mapToRedux} 
                                  updateProgressBar={updateColumn1Count} />

                              </div>
                            </Col>
                          </Row>
                          :
                          <></>
                        }
                        {/* Render the translation type components */}
                        {
                          translationState.translationTypes.includes("Evaluations") ?
                          <Row>
                            <Col>
                              <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginBottom: '12px', width: '80%',  }}>
                                
                                  <TranslationContent_Evaluations 
                                  key={""} 
                                  valueInField={translationState.evaluationsText} 
                                  classesToAdd={"required-adjusted-left"} 
                                  required={true} 
                                  triggerUpdateFromParent={mapToRedux} 
                                  updateProgressBar={updateColumn1Count} />

                              </div>
                            </Col>
                          </Row>
                          :
                          <></>
                        }
                        {/* Render the translation type components */}
                        {
                          translationState.translationTypes.includes("Other") ?
                          <Row>
                            <Col>
                              <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginBottom: '12px', width: '80%',  }}>
                                
                                  <TranslationContent_Other 
                                  key={""} 
                                  valueInField={translationState.otherText} 
                                  classesToAdd={"required-adjusted-left"} 
                                  required={true} 
                                  triggerUpdateFromParent={mapToRedux} 
                                  updateProgressBar={updateColumn1Count} />

                              </div>
                            </Col>
                          </Row>
                          :
                          <></>
                        }

                                                                        <Row>
                          <Col>
                            <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '0px', marginLeft: '2px' }}>
                              <DatePicker_Simple required={true} minDate={today} valueInField={new Date(translationState.dueDateText) | ''} classesToAdd={"required-adjusted-date"} triggerUpdateInParent={mapToRedux} id="dueDateText" className="date-picker-main" label="Date Due" selected={startDueDate} onChange={date => setStartDueDate(date)} />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '0px' }}>
                              <Dropdown_Advanced required={true} valueInField={translationState.languageDropdown} classesToAdd={"required-adjusted-lower"} options={languages} prompt='Language' renderOther={setRenderOtherLang} id="languageDropdown" label="name" triggerUpdateInParent={mapToRedux} />
                            </div>
                          </Col>
                        </Row>
                        {
                          translationState.languageDropdown == "Other" ?
                        <Row>
                          <Col>
                            <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '7px', marginBottom: '7px' }}>
                                 <TextFields_Outlined valueInField={translationState.otherLanguageText} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="otherLanguageText" label="Other Language" />
                                
                            </div>
                          </Col>
                        </Row> : <></>}



                        <Row>
                            <Col>
                              <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '0px', marginLeft: '7px' }}>
                                <div style={{ width: '80%'}}>
                                  <b>Notes:</b>
                                  <TextArea_Simple id="districtNotes" 
                                    classesToAdd={""}
                                    valueInField={translationState.districtNotes}
                                    triggerUpdateInParent={mapToRedux}
                                    placeholder="Please enter any notes such as alternate dates or times." 
                                    rows={3} 
                                    minrows={3} 
                                    maxrows={5} 
                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>

                              
                            
                      </CardContent>
                    </Card>
                  </Box>          
              </Row>
            </Row>
          </Container>
          <div className="form-button-bottom-container">
            <Button className="btn btn-primary form-button-bottom" onClick={() => runAllValidations()}
              variant="contained" color="primary">
              Next Page
            </Button>
          </div>
      </FadeIn>
    </div>
    </ThemeProvider>
  )
}

export default TranslationContent
